import request from '@/scripts/request';
export const commonApis = {
  userList() {
    return request('/api/v1/debug/users');
  },
  chatList(params: any) {
    return request('/api/v1/debug/user/chats', {
      method: 'POST',
      data: params,
    });
  },
  groupList() {
    return request('/api/v1/debug/groups');
  },
  sendList(params: any) {
    return request('/api/v1/debug/send/log', {
      method: 'POST',
      data: params,
    });
  },
  noticeList(params: any) {
    return request('/api/v1/debug/notice/log', {
      method: 'POST',
      data: params,
    });
  },
  pullList(params: any) {
    return request('/api/v1/debug/pull/log', {
      method: 'POST',
      data: params,
    });
  },
  sendSingle(params: { count: number; open: 0 | 1; msgCount?: number }) {
    return request('/api/v1/push/test/users/msg', {
      params,
      msg: true,
    });
  },
  sendGroup(params: {
    count: number;
    open: 0 | 1;
    msgCount?: number;
    groupId: string;
  }) {
    return request('/api/v1/push/test/group/msg', {
      params,
      msg: true,
    });
  },
};
